import { availableLanguages } from '@codeblock/core';

var noop = function noop() {
  return null;
};

export default availableLanguages.reduce(function (result, language) {
  var _a;

  return Object.assign(result, (_a = {}, _a[language] = noop, _a));
}, {});